import {createFileRoute} from '@tanstack/react-router';

export const Route = createFileRoute('/_app/components/settings')({
  beforeLoad() {
    return {
      title: 'Component Settings',
      breadcrumb: {
        label: 'Settings',
      },
    };
  },
});
